export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-40--g1.ed13d478.png";